import React from 'react';
import './PartnerHero.css';

const PartnerHero = () => {
  return (
    <section className="partner-hero">
      <div className="container">
        <div className="partner-hero-content">
          <div className="program-tag">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.5"/>
              <path d="M8 4V8L10 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
            <span>Partner Program</span>
          </div>
          <h1 className="partner-hero-title">
            Earn <span className="earnings-highlight">₹40,000-₹80,000</span> Monthly as a Hopmate Partner
          </h1>
          <p className="partner-hero-description">
            Join over 1,000+ creators who are building thriving communities and sustainable incomes on India's fastest-growing voice platform.
          </p>
          <a 
            href="https://forms.gle/BqwhQXFZpfiouwds9" 
            target="_blank" 
            rel="noopener noreferrer"
            className="partner-cta-button"
          >
            Apply to Become a Partner
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default PartnerHero;

